module.exports = __webpack_public_path__ + "static/media/CT_2019_30442A.1dfee295.png";